export const ThemeMode = {
  System: 'system',
  Dark: 'dark',
  Light: 'light',
} as const

export const ThemeModes = [ThemeMode.System, ThemeMode.Dark, ThemeMode.Light] as const

export type ThemeMode = (typeof ThemeMode)[keyof typeof ThemeMode]
export type ResolvedTheme = typeof ThemeMode.Dark | typeof ThemeMode.Light

export function isThemeMode(value: unknown): value is ThemeMode {
  return ThemeModes.some((mode) => mode === value)
}

export function resolveTheme(mode: ThemeMode, prefersDark: boolean): ResolvedTheme {
  if (mode === ThemeMode.Dark || (mode === ThemeMode.System && prefersDark)) return ThemeMode.Dark
  return ThemeMode.Light
}

export function applyThemeMode(mode: ThemeMode, prefersDark: boolean): void {
  const resolvedTheme = resolveTheme(mode, prefersDark)
  const root = document.documentElement

  root.classList.toggle(ThemeMode.Dark, resolvedTheme === ThemeMode.Dark)
  root.classList.toggle(ThemeMode.Light, mode === ThemeMode.Light)
  root.style.colorScheme = resolvedTheme
}
